module.exports = new __parcel__URL__("reparent-onboarding-light.f5faa58e.gif").toString();